import request from '../request'


export function getResolution(ques_id) {
    return request({
        url: `/errquestion/resolution?ques_id=${ques_id}`,
        method: 'get',

    })
}